module.exports = __webpack_public_path__ + "img/idcard_1@2x.a17d2843.png";